export default "__VITE_ASSET__EbgMAff3__"